import { render } from "./Portal.vue?vue&type=template&id=6840edea&scoped=true"
import script from "./Portal.vue?vue&type=script&lang=js"
export * from "./Portal.vue?vue&type=script&lang=js"

import "./Portal.vue?vue&type=style&index=0&id=6840edea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6840edea"]])

export default __exports__